import { render, staticRenderFns } from "./listDocuments.vue?vue&type=template&id=7f570588&"
import script from "./listDocuments.vue?vue&type=script&lang=js&"
export * from "./listDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports